import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  HeaderWrapper,
  Month,
  PrevArrow,
  NextArrow,
  MonthDays,
  Day
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { WeekDays } from '@app/src/common/datePicker/components/WeekDays';
import { MONTHS, STATE_MONTHS } from '@app/src/common/datePicker/state/calendar/constants';
import { getPrevDate, getNextDate } from '@app/src/common/datePicker/state/calendar/utils';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { CATEGORY } from '@app/src/config/categories';
import { COLORS } from '@app/src/ui';

interface Props {
  onClickDay: Function;
  dateSelected: DateSelectedType[];
  categoryId?: number;
  isDisabledRest?: boolean;
}

export const Calendar: React.FC<Props> = ({
  onClickDay,
  dateSelected,
  categoryId,
  isDisabledRest
}) => {
  const [ calendarPosition, setCalendarPosition ] = useState(0);
  const calendarMonths = useSelector(state => state.calendar.calendarMonths);
  const daysByMonth = calendarMonths[calendarPosition];
  const currentDay = new Date().getDate();
  const month = new Date().getMonth();
  const year = new Date().getFullYear();
  const [ calendar, setCalendar ]  = useState({ month, year });

  const handleClickPrevMonth = () => {
    setCalendarPosition(calendarPosition - 1);
    setCalendar(getPrevDate(calendar));
  };

  const handleClickNextMonth = () => {
    setCalendarPosition(calendarPosition + 1);
    setCalendar(getNextDate(calendar));
  };

  const handleClickDay = (day: DayType) => {
    if (day.stateMonth === STATE_MONTHS.PREV) {
      setCalendarPosition(calendarPosition - 1);
      setCalendar(getPrevDate(calendar));
    }
    if (day.stateMonth === STATE_MONTHS.NEXT) {
      setCalendarPosition(calendarPosition + 1);
      setCalendar(getNextDate(calendar));
    }
    onClickDay && onClickDay(day);
  };

  const isLeftArrowDisabled = () => calendarPosition === 0;

  const isRightArrowDisabled = () => calendarPosition === calendarMonths.length - 1;

  return (
    <React.Fragment>
      <HeaderWrapper>
        <PrevArrow onClick={handleClickPrevMonth} isDisabled={isLeftArrowDisabled()}>
          <Icon
            data-name="icon-back"
            width="16"
            height="12"
            fill={COLORS.BLUE_LINK}
          />
        </PrevArrow>
        <Month>{MONTHS[calendar.month]} {calendar.year}</Month>
        <NextArrow onClick={handleClickNextMonth} isDisabled={isRightArrowDisabled()}>
          <Icon
            data-name="icon-back"
            width="16"
            height="12"
            fill={COLORS.BLUE_LINK}
          />
        </NextArrow>
      </HeaderWrapper>
      <WeekDays />
      <MonthDays>
        {daysByMonth && daysByMonth.length > 0 && daysByMonth.map((day, index) => {
          const isSelected = Boolean(dateSelected && dateSelected.filter(e => {
            return day && e && e.dayMonth === day.dayMonth && e.month === day.month && e.year === day.year
          }).length);
          return(
            <Day
              key={index}
              isDayMonth={!day.dayMonth}
              current={day.dayMonth === currentDay && month === day.month && year === day.year}
              selected={isSelected}
              isDayOtherMonth={day.otherDayMonth}
              isDisabled={day.disabled || !day.disabled  && !isSelected && isDisabledRest}
              onClick={() => handleClickDay(day)}
              categoryName={CATEGORY[categoryId]}
            >
              {day.dayMonth}{day.otherDayMonth}
            </Day>
          )
        })}
      </MonthDays>
    </React.Fragment>
  )
}
